const appEnv = process.env.NEXT_PUBLIC_APP_ENV;
const apiHostBase = (
  appEnv === 'prd'
    ? process.env.K1561_PRD_DIARIOOFICIALMS_API_SERVICE_HOST
    : process.env.K1561_HOM_DIARIOOFICIALMS_API_SERVICE_HOST
) as string;
const pathBase = process.env.API_PATH_BASE as string;

export const backendHost = `http://${apiHostBase}${pathBase}`;

export const clientIdGovBR = process.env.NEXT_PUBLIC_CLIENT_ID_GOV_BR as string;

export const urlRedirectGovBR = process.env.NEXT_PUBLIC_REDIRECT_URL_GOV_BR as string;
